import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-green" }
const _hoisted_2 = { class: "text-red" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_bar_chart = _resolveComponent("bar-chart")!
  const _component_AuditCheckAlertButton = _resolveComponent("AuditCheckAlertButton")!
  const _component_BankReconciliationDiscrepancyDialog = _resolveComponent("BankReconciliationDiscrepancyDialog")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_hover = _resolveComponent("v-hover")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_hover, null, {
      default: _withCtx(({ isHovering, props }) => [
        _createVNode(_component_v_card, _mergeProps(props, {
          elevation: isHovering ? 4 : 0,
          class: 
                    _ctx.$vuetify.display.mobile
                        ? 'default_card_mobile dashboard_card d-flex flex-column ma-0'
                        : 'default_card dashboard_card d-flex flex-column ma-0'
                ,
          style: _ctx.$vuetify.display.mobile ? 'height: 100%' : 'height: 250px'
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "title ma-2"
                }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" Trésorerie ")
                  ])),
                  _: 1
                }),
                (_ctx.isTotalBalanceLoading)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "12",
                      class: "px-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_skeleton_loader, { type: "card" })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isTotalBalanceLoading)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "12",
                      class: "px-4"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.vueGraph)
                          ? (_openBlock(), _createBlock(_component_v_row, {
                              key: 0,
                              "no-gutters": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: _ctx.$vuetify.display.mdAndDown ? '12' : '7',
                                  class: "d-flex justify-center align-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h1", null, _toDisplayString(_ctx.totalLastReconciledBalance
                                            ? _ctx.newCommonFormatCurrency(
                                                  _ctx.totalLastReconciledBalance?.balance,
                                                  undefined,
                                              )
                                            : "-"), 1)
                                  ]),
                                  _: 1
                                }, 8, ["cols"]),
                                _createVNode(_component_v_col, {
                                  class: "d-flex justify-end align-center",
                                  cols: _ctx.$vuetify.display.mdAndDown ? '12' : '5'
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode("Entrées ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "d-flex font-weight-bold justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              class: "mx-1",
                                              color: "green",
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode("$fa-caret-up")
                                              ])),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                    _ctx.bankTransactionAggregate.amountDebit,
                                                    undefined,
                                                )), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "4",
                                          class: "d-flex"
                                        }, {
                                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                                            _createTextVNode("Sorties ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "8",
                                          class: "d-flex font-weight-bold justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              class: "mx-1",
                                              color: "new_red",
                                              size: "x-small"
                                            }, {
                                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode("$fa-caret-down")
                                              ])),
                                              _: 1
                                            }),
                                            _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.newCommonFormatCurrency(
                                                _ctx.bankTransactionAggregate.amountCredit,
                                                undefined,
                                            )), 1)
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "d-flex mt-2"
                                        }, {
                                          default: _withCtx(() => _cache[8] || (_cache[8] = [
                                            _createTextVNode(" Entrées/sorties sur le dernier mois ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["cols"])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_v_row, {
                              key: 1,
                              "no-gutters": "",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "8" }, {
                                  default: _withCtx(() => [
                                    (_ctx.chartData)
                                      ? (_openBlock(), _createBlock(_component_bar_chart, {
                                          key: 0,
                                          data: _ctx.chartData,
                                          options: _ctx.options,
                                          height: _ctx.$vuetify.display.mobile ? 100 : 140,
                                          width: 200
                                        }, null, 8, ["data", "options", "height"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isTotalBalanceLoading)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 2,
                      cols: "12",
                      class: "mt-auto"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_row, {
                          "no-gutters": "",
                          class: "px-2 pt-2 pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, {
                              cols: "5",
                              class: "d-flex justify-center"
                            }),
                            _createVNode(_component_v_col, {
                              cols: "2",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                (_ctx.showReconciliationDiscrepancyAlertButton)
                                  ? (_openBlock(), _createBlock(_component_AuditCheckAlertButton, {
                                      key: 0,
                                      auditCheckType: "Bank",
                                      unreconciledBalancesAccountNames: 
                                        _ctx.unreconciledBalancesAccountNames
                                    ,
                                      onAuditCheckAlertButtonClicked: _ctx.onAuditCheckAlertButtonClick
                                    }, null, 8, ["unreconciledBalancesAccountNames", "onAuditCheckAlertButtonClicked"]))
                                  : _createCommentVNode("", true),
                                (_ctx.showBankReconciliationDiscrepancyDialog)
                                  ? (_openBlock(), _createBlock(_component_BankReconciliationDiscrepancyDialog, {
                                      key: 1,
                                      modelValue: _ctx.showBankReconciliationDiscrepancyDialog,
                                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showBankReconciliationDiscrepancyDialog) = $event)),
                                      accountingPeriodId: _ctx.accountingPeriod?.id,
                                      companyId: _ctx.companyId,
                                      width: "800px"
                                    }, null, 8, ["modelValue", "accountingPeriodId", "companyId"]))
                                  : _createCommentVNode("", true),
                                isHovering
                                  ? _withDirectives((_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 2,
                                      icon: _ctx.vueGraph ? '$fa-euro-sign' : '$fa-chart-bar',
                                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.vueGraph = !_ctx.vueGraph)),
                                      "data-cy": "CardBank-ChartOrEuroButton-ClickToggle"
                                    }, null, 8, ["icon"])), [
                                      [_vShow, _ctx.accounts.length]
                                    ])
                                  : _createCommentVNode("", true),
                                isHovering
                                  ? (_openBlock(), _createBlock(_component_v_btn_icon, {
                                      key: 3,
                                      icon: "$fa-search-plus",
                                      class: "mr-1",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('onVueDetailedChanged'))),
                                      "data-cy": "CardBank-searhPlus"
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            (_ctx.formattedTotalBalanceDate)
                              ? (_openBlock(), _createBlock(_component_v_col, {
                                  key: 0,
                                  class: "d-flex align-end justify-end"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", null, "Solde au " + _toDisplayString(_ctx.formattedTotalBalanceDate), 1)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1040, ["elevation", "class", "style"])
      ]),
      _: 1
    })
  ]))
}